import { apiClient } from '@repo/shared';

const initialiseNewSchool = () => {
  return {
    id: null,
    name: "",
    address: "",
    phoneNumber: "",
    yearRange: "",
    createdAt: "",
    updatedAt: "",
    parentInfo: "",
    kindergarten: false,
  };
}

const getAll = async () => {
  const schools = await apiClient.get("/api/schools");
  return schools;
};

const get = async (id) => {
  const school = await apiClient.get(`/api/schools/${id}`);
  return school?.[0];
};

const create = async (school) => {
  return await apiClient.post(`/api/schools`, school);
};

const update = async (id, school) => {
  return await apiClient.post(`/api/schools/${id}`, school);
};

const remove = async (id) => {
  //return http.delete(`/klassen/${id}`);
  const schools = await apiClient.delete(`/api/schools/${id}`);
  return schools;
};

const getEmailForParents = async (schoolId) => {
  const emailTemplate = await apiClient.get(`/api/schools/${schoolId}/emailForParents`);
  return emailTemplate;
};

const SchoolService = {
  getAll,
  get,
  create,
  update,
  remove,
  initialiseNewSchool,
  getEmailForParents,
};

export default SchoolService;